import { useAnalytics } from '@medely/ui-kit';
import { useCurrentUser } from '../useCurrentUser';
import { useOTAMetadata } from '../useOTAMetadata';

type Platform = 'web' | 'mobile';
type Source = 'auto' | 'help_icon';

export function useApplicationVideoEvent() {
  const analytics = useAnalytics();
  const { currentUser } = useCurrentUser();
  const accountId = currentUser?.professional?.id;
  const otaMetadata = useOTAMetadata();

  const trackVideoPlayed = ({ platform, source }: { platform: Platform; source: Source }) => {
    analytics.track('Application - Video Modal - Video Played', {
      context: 'Application',
      subcontext: 'Video Modal',
      action: 'Video Played',
      account_id: accountId,
      platform,
      source,
      ...otaMetadata,
    });
  };

  const trackDismissed = ({ platform, source }: { platform: Platform; source: Source }) => {
    analytics.track('Application - Video Modal - Dismissed', {
      context: 'Application',
      subcontext: 'Video Modal',
      action: 'Dismissed',
      account_id: accountId,
      platform,
      source,
      ...otaMetadata,
    });
  };

  return { trackVideoPlayed, trackDismissed };
}
